'use client';
import React from 'react';
import { EmblaOptionsType } from 'embla-carousel';
import { DotButton, useDotButton } from './EmblaCarouselDotButton';
import { PrevButton, NextButton, usePrevNextButtons } from './EmblaCarouselArrowButtons';
import useEmblaCarousel from 'embla-carousel-react';
import Image from 'next/image';
import styles from './styles/EmblaCarousel.module.css';

function getFullUrl(relativeUrl: string) {
    const assetsBaseUrl = process.env.NEXT_PUBLIC_STRAPI_URL_INTERNAL;
    return `${assetsBaseUrl}${relativeUrl}`;
}

type PropType = {
    slides: any[];
    options?: EmblaOptionsType;
};

export default function Index({ slides, options }: PropType) {
    const [emblaRef, emblaApi] = useEmblaCarousel(options);

    const { selectedIndex, scrollSnaps, onDotButtonClick } = useDotButton(emblaApi);
    const { prevBtnDisabled, nextBtnDisabled, onPrevButtonClick, onNextButtonClick } = usePrevNextButtons(emblaApi);

    return (
        <section className={styles.embla}>
            <div className={styles.embla__viewport} ref={emblaRef}>
                <div className={styles.embla__container}>
                    {slides.map((slide) => {
                        const imageUrl = getFullUrl(slide.Image.data.attributes.url);
                        const imageAlt = slide.Image.data.attributes.alternativeText || 'Equipment';
                        const imageWidth = slide.Image.data.attributes.width;
                        const imageHeight = slide.Image.data.attributes.height;
                        return (
                            <div className={styles.embla__slide} key={slide.id}>
                                <Image
                                    // prettier-ignore
                                    src={imageUrl}
                                    alt={imageAlt}
                                    width={imageWidth}
                                    height={imageHeight}
                                />
                            </div>
                        );
                    })}
                </div>
                <div className="absolute top-1/2 left-2 transform -translate-y-1/2">
                    <PrevButton onClick={onPrevButtonClick} disabled={prevBtnDisabled} />
                </div>

                <div className="absolute top-1/2 right-2 transform -translate-y-1/2">
                    <NextButton onClick={onNextButtonClick} disabled={nextBtnDisabled} />
                </div>
            </div>

            <div className={styles.embla__dots}>
                {scrollSnaps.map((_, index) => (
                    <DotButton key={index} onClick={() => onDotButtonClick(index)} className={`${styles.embla__dot} ${index === selectedIndex ? styles['embla__dot--selected'] : ''}`} />
                ))}
            </div>
        </section>
    );
}
